import React from 'react'

import { DashboardChartPaper, RadialGradientChart } from 'components'

const StatsChartCard = ({ title, value }) => (
  <DashboardChartPaper title={title} noMaxHeight>
    <RadialGradientChart value={value ?? 0} height={230} />
  </DashboardChartPaper>
)

export default StatsChartCard
